<template>
  <div>
    <section v-if="showBox" class="section feature-bg">
      <div class="columns">
        <div class="column is-8-desktop is-offset-2-desktop">
          <div class="box bs">
            <EditProject
              v-if="showBox"
              v-model="showBox"
              title="Lägg till projekt"
              @saved="AddProject"
            ></EditProject>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-orange mt mb">
      <div class="container has-text-white">
        <div class="columns is-multiline">
          <div class="column is-6">
            <h1 class="title has-text-white is-uppercase">
              Projekt
              <span
                v-if="this.$store.state.auth.success"
                class="icon clickable"
                @click="showBox = true"
              >
                <i class="fas fa-plus-circle is-size-4" aria-hidden="true"></i>
              </span>
            </h1>
          </div>
          <div class="column is-6">
            <div class="tags is-pulled-right">
              <span
                v-for="(tag, index) in tags"
                :key="index"
                class="tag is-capitalized clickable"
                :class="{ 'is-success': filter == tag }"
                @click="SetFilter(tag)"
                >{{ tag }}</span
              >
            </div>
          </div>

          <div
            v-for="item in filteredItems"
            :key="item.card.uid"
            class="column is-3"
            :draggable="$store.state.auth.success"
            @dragstart="ordering = item"
            @dragover.prevent
            @drop.prevent="Reorder(item)"
          >
            <ProjectImage
              :hidden="false"
              :title="item.card.title"
              :subtitle="item.card.subtitle"
              :image="GetCover(item)"
              :link="`/projekt/${item.card.path}`"
            ></ProjectImage>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import ProjectImage from "@/components/singles/ProjectImage.vue";
import EditProject from "@/components/main/EditProject.vue";

export default {
  components: { ProjectImage, EditProject },
  data() {
    return {
      filter: "alla",
      showBox: false,
      items: [],
      tags: [],
    };
  },
  computed: {
    filteredItems() {
      if (this.filter && this.filter != "alla") {
        return this.items.filter(
          (x) => x.card.subtitle.toLowerCase() == this.filter
        );
      }

      return this.items;
    },
  },

  created() {
    window.scrollTo(0, 0);
    this.Getitems();
    this.GetFilter();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    SetFilter(tag) {
      this.filter = tag;
      this.$router.push({ query: { filter: encodeURIComponent(tag) } });
    },
    GetFilter() {
      if (this.$route.query.filter && this.$route.query.filter != "") {
        this.filter = decodeURIComponent(this.$route.query.filter);
      }
    },
    GetCover(item) {
      if (item.images && item.images.length != 0) {
        return `${this.$helpers.url}image/${item.images[0].name}`;
      }
      //return "require("@/assets/img/no-image.svg"")
      return "";
    },
    async Getitems() {
      let result = await this.$helpers.PostApi(
        "get/pageCards",
        {
          pageName: "/projects",
          active: this.$store.state.auth.success ? null : true,
          cover: true,
        },
        true
      );

      this.items = this.OrderItems(result);

      const tags = this.GetTags(this.items);
      this.tags = tags.filter((x) => x && x != "text saknas");
    },

    GetTags(items, addAll = true) {
      if (addAll) {
        return [
          "alla",
          ...new Set(items.map((x) => x.card.subtitle.toLowerCase())),
        ];
      } else {
        return [...new Set(items.map((x) => x.card.subtitle.toLowerCase()))];
      }
    },

    async Reorder(item) {
      if (
        this.$store.state.auth.role.level <= 2 &&
        item.card.uid != this.ordering.card.uid
      ) {
        let order = this.ordering.card.order;

        this.ordering.card.order = item.card.order;
        item.card.order = order;

        await this.$helpers.PostApi("set/pageCard", {
          pageName: "/projects",
          uid: this.ordering.card.uid,
          object: { order: this.ordering.card.order },
        });

        await this.$helpers.PostApi("set/pageCard", {
          pageName: "/projects",
          uid: item.card.uid,
          object: { order: item.card.order },
        });

        this.items = this.OrderItems(this.items);
        this.$helpers.ShowStatus("Sparat.", 3000, "success");
      }
    },

    OrderItems(items) {
      return [...items].sort((a, b) => {
        if (a.card.order > b.card.order) {
          return 1;
        }
        if (b.card.order > a.card.order) {
          return -1;
        }

        return 0;
      });
    },

    AddProject(newProject) {
      this.items = this.OrderItems([newProject, ...this.items]);
      this.tags = this.GetTags(this.items);
      this.showBox = false;
    },
    uploadImageClicked() {},
  },
};
</script>
